import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import { typeForDraft } from "app/pages/automations/rules/types";

// Los borradores de Xpit Assistant se aplican desde cualquier página: llevan a la vista que los abre, con el mensaje
// en el state de la navegación. Un dashboard va a Dashboards (que lo carga en modo edición) y una automatización abre
// el editor de su tipo, nuevo o el de la que propone cambiar. Nada se guarda hasta que el usuario lo hace ahí.
export const openAssistantDraft = (message, navigate, location) => {
    if (message?.draft_type === "dashboard") {
        navigate("/automations/dashboards", { state: { assistantDraft: message } });
        return;
    }

    const type = typeForDraft(message?.draft_type);
    if (!type) throw new Error(`Tipo de borrador desconocido: ${message?.draft_type}`);

    const from = location?.state?.from || `${location?.pathname || ""}${location?.search || ""}`;
    const targetId = type.draftTarget?.(message);
    navigate(targetId ? `/automations/rules/${type.key}/${targetId}` : `/automations/rules/new/${type.key}`, {
        state: { assistantDraft: message, from },
    });
};

export const draftIcon = (draftType) => (
    draftType === "dashboard" ? DashboardCustomizeOutlinedIcon : typeForDraft(draftType)?.icon || BoltOutlinedIcon
);

export const draftActionLabel = (draftType) => (draftType === "dashboard" ? "Aplicar" : "Abrir");
